<template>
  <div v-if="content" v-editable="content" id="nos-parcs">
    <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      content: null,
      id: this.$route.params.id
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get(
          `cdn/stories/${this.$i18n.locale}/pages/nos-parcs`
        );
        this.content = res.data.story.content;
      } catch (err) {
        this.$router.push("/404");
      }
    }
  }
};
</script>

<style lang="scss">
#nos-parcs {
  padding-top: 1em;
  .list {
    justify-content: space-around;
  }
}
</style>
